import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TEigyosyoKanListGetReq, TEigyosyoKanListGetRes } from "./TEigyosyoKan"

/**
 * 営業所管マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class EigyosyoKanService
 * @extends {ConnectApi}
 */
export default class EigyosyoKanService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  getList = async (params?: TEigyosyoKanListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TEigyosyoKanListGetRes>> =
        await this.getInner(`/master/eigyosyokan`, params)
      return res.data
    } catch (error) {
      throw error
    }
  }
}
